import { useState } from "react";
import { Search, Bell, CommandIcon, HelpCircle, ChevronDown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TopBar({ title, breadcrumb = [] }) {
  const { user } = useAuth();
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-30 h-14 border-b border-border bg-[#0a0a0a]/90 backdrop-blur flex items-center px-4 md:px-6 gap-4">
      {/* Breadcrumb */}
      <div className="hidden md:flex items-center gap-2 text-xs font-mono text-ink-dim min-w-0">
        {breadcrumb.map((b, i) => (
          <div key={`${i}-${b}`} className="flex items-center gap-2 min-w-0">
            {i > 0 && <span className="text-ink-faint/50">/</span>}
            <span className={i === breadcrumb.length - 1 ? "text-white truncate" : "truncate"}>{b}</span>
          </div>
        ))}
      </div>

      {/* Command palette / search */}
      <div className="flex-1 flex justify-center">
        <button className="inline-flex items-center gap-2.5 px-3 py-1.5 rounded-md bg-surface border border-border text-xs text-ink-dim hover:border-border/80 w-full max-w-md">
          <Search className="w-3.5 h-3.5" />
          <span className="flex-1 text-left">Hızlı arama…</span>
          <span className="flex items-center gap-1 text-[10px] font-mono text-ink-faint">
            <kbd className="px-1 py-0.5 rounded bg-bg border border-border">⌘</kbd>
            <kbd className="px-1 py-0.5 rounded bg-bg border border-border">K</kbd>
          </span>
        </button>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-1">
        <button
          className="p-2 rounded-md text-ink-dim hover:text-white hover:bg-white/5 relative"
          title="Bildirimler"
          onClick={() => setAlertsOpen(!alertsOpen)}
        >
          <Bell className="w-4 h-4" />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-brand animate-pulse" />
        </button>
        <button className="p-2 rounded-md text-ink-dim hover:text-white hover:bg-white/5" title="Yardım">
          <HelpCircle className="w-4 h-4" />
        </button>

        <div className="w-px h-5 bg-border mx-2" />

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-white/5"
        >
          <div className="w-7 h-7 rounded-full bg-gradient-to-br from-brand to-brand-hover grid place-items-center text-xs font-bold">
            {user?.name?.[0]?.toUpperCase() || "A"}
          </div>
          <ChevronDown className="w-3.5 h-3.5 text-ink-dim" />
        </button>
      </div>
    </header>
  );
}
